'use client';

import React, { useState } from 'react';
import { useDatadogTracking } from '@/app/hooks/useDatadogTracking';

interface CodeExampleProps {
  title: string;
  description?: string;
  requestType?: string;
  requestUrl?: string;
  responseType?: string;
  responseContent?: string;
}

export default function CodeExample({
  title,
  description,
  requestType = 'GET Request',
  requestUrl,
  responseType = 'JSON Response',
  responseContent
}: CodeExampleProps) {
  const { trackCodeExampleCopy } = useDatadogTracking();
  const [copiedRequest, setCopiedRequest] = useState(false);
  const [copiedResponse, setCopiedResponse] = useState(false);

  const copyToClipboard = async (text: string, type: 'request' | 'response') => {
    try {
      await navigator.clipboard.writeText(text);
      
      // Track the copy action
      trackCodeExampleCopy(type === 'request' ? 'curl' : 'json', requestUrl);
      
      // Show feedback
      if (type === 'request') {
        setCopiedRequest(true);
        setTimeout(() => setCopiedRequest(false), 2000);
      } else {
        setCopiedResponse(true);
        setTimeout(() => setCopiedResponse(false), 2000);
      }
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };
  return (
    <div className="mb-8">
      <h3 id={`example-${title.toLowerCase().replace(/[^a-z0-9]/g, '-')}`}>{title}</h3>
      {description && <p>{description}</p>}
      
      {requestUrl && (
        <>
          <h4>Request</h4>
          <div className="code-snippet-container">
            <div className="code-header flex justify-between items-center">
              <span>{requestType}</span>
              <button
                onClick={() => copyToClipboard(requestUrl, 'request')}
                className="px-2 py-1 text-xs bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
              >
                {copiedRequest ? 'Copied!' : 'Copy'}
              </button>
            </div>
            <div className="code-content-wrapper">
              <pre className="m-0 border-0 bg-transparent rounded-none"><code dangerouslySetInnerHTML={{ __html: requestUrl }} /></pre>
            </div>
          </div>
        </>
      )}
      
      {responseContent && (
        <>
          <h4>Response</h4>
          <div className="code-snippet-container">
            <div className="code-header flex justify-between items-center">
              <span>{responseType}</span>
              <button
                onClick={() => copyToClipboard(responseContent, 'response')}
                className="px-2 py-1 text-xs bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
              >
                {copiedResponse ? 'Copied!' : 'Copy'}
              </button>
            </div>
            <div className="code-content-wrapper">
              <pre className="m-0 border-0 bg-transparent rounded-none"><code>{responseContent}</code></pre>
            </div>
          </div>
        </>
      )}
    </div>
  );
} 